import { useQuery } from "@common/utils/use-query";
import { IConfig } from "@stores/config/types";

export function useGetConfig() {
  return useQuery<IConfig>(
    { url: "/config" },
    {
      refetchInterval: 1000 * 60 * 60 * 12, // reload every 12 hours
      refetchIntervalInBackground: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: true,
    },
  );
}
